<template>
  <RCard>
    <CreateSubjectCategoryModal v-model="subjectCategoryModal" @save="createSubjectCategory" />

    <Grid gaf="column" justify-content="space-between" align-items="center">
      <div class="text-subtitle-1 text-secondary-2">Subject categories</div>
      <RBtn type="text" size="small">
        <PlusIcon />
        <RPopup :items="subjectCategoriesToAssign" @popup-item="onSubjectCategory" />
      </RBtn>
    </Grid>

    <div class="q-mt-md flex" style="gap: var(--r-space-md)">
      <div
        v-for="subjectCategory of sortedSubjectCategories"
        :key="subjectCategory.id"
        class="subject-category"
        :class="{ main: subjectCategory.is_main_category }"
      >
        <Grid gaf="column" gap="var(--r-space-xs)">
          {{ subjectCategory.name }}
          <DotsIcon
            :popup-items="subjectCategoryOptions(subjectCategory)"
            color="white"
            @popup-item="onSubjectCategoryOption"
          />
        </Grid>
      </div>

      <div v-if="!sortedSubjectCategories.length" class="text-body-1 text-secondary-1">
        No subject category is available to this product
      </div>
    </div>
  </RCard>
</template>

<script>
// Libraries
import { mapState, mapActions } from 'vuex'
import { orderBy } from 'lodash'
// Components
import PlusIcon from '@/ui/icons/PlusIcon'
import RPopup from '@/ui/RPopup'
import DotsIcon from '@/ui/icons/DotsIcon'
import CreateSubjectCategoryModal from '@/reusable/CreateSubjectCategoryModal'

export default {
  components: {
    PlusIcon,
    RPopup,
    DotsIcon,
    CreateSubjectCategoryModal
  },

  data: () => ({
    subjectCategoryModal: false
  }),

  computed: {
    ...mapState('product-show', ['allSubjectCategories', 'assignedSubjectCategories']),

    subjectCategoriesToAssign() {
      const all = this.allSubjectCategories
      const assigned = this.assignedSubjectCategories
      const notAssignedFilter = subjCatFromAll => {
        return !assigned.find(subjCatFromAssigned => subjCatFromAssigned.id === subjCatFromAll.id)
      }
      const notAssigned = all.filter(notAssignedFilter)

      return [
        { name: 'new-subject-category', label: 'Create subject category', borderBottom: true, stickyTop: true },
        ...notAssigned.map(subCategory => ({
          name: subCategory.name,
          label: subCategory.name,
          id: subCategory.id,
          isMain: subCategory.is_main_category
        }))
      ]
    },

    sortedSubjectCategories() {
      return orderBy(this.assignedSubjectCategories, ['is_main_category', 'name'], ['desc', 'asc'])
    },

    subjectCategoryOptions() {
      return subjectCategory => {
        return [
          ...(subjectCategory.is_main_category
            ? []
            : [{ name: 'set-main', label: 'Set as main category', subjectCategory }]),
          { name: 'disassociate', label: 'Disassociate from product', subjectCategory }
        ]
      }
    }
  },

  methods: {
    ...mapActions('product-show', [
      'assignSubjectCategory',
      'changeMainCategory',
      'createSubjectCategory',
      'removeFromProduct'
    ]),

    onSubjectCategory(item) {
      if (item.name === 'new-subject-category') this.subjectCategoryModal = true
      else this.assignSubjectCategory(item.id)
    },

    onSubjectCategoryOption(item) {
      if (item.name === 'set-main') this.changeMainCategory({ main_subject_category_id: item.subjectCategory.id })
      else if (item.name === 'disassociate') this.removeFromProduct(item.subjectCategory)
    }
  }
}
</script>

<style lang="scss" scoped>
.subject-category {
  background: var(--r-secondary-3);
  padding: var(--r-space-sm) var(--r-space-md);
  padding-right: var(--r-space-xs);
  border-radius: var(--r-space-xs);
  color: white;

  &.main {
    background: var(--r-graph-to-renew);
  }
}
</style>
